import React from "react";
import {} from "../redux/actions";
import { connect } from "react-redux";
import OverviewList from "./OverviewList";
import EmployeeList from "./EmployeeList";
import MachinesList from "./MachinesList";
import EquipmentList from "./EquipmentList";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import AgendaIcon from "@material-ui/icons/ViewAgenda";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import TodayIcon from "@material-ui/icons/Today";
import CardHeader from "@material-ui/core/CardHeader";
import Avatar from "@material-ui/core/Avatar";
import red from "@material-ui/core/colors/red";
import BuildIcon from "@material-ui/icons/Build";
import LocalShippingIcon from "@material-ui/icons/LocalShipping";
import PersonIcon from "@material-ui/icons/Person";
import { withStyles } from "@material-ui/core/styles";
import { selectClickedDayTimeBlock } from "../redux/selectors";
import SwipeableViews from "react-swipeable-views";
import { setAgendaItemDragging, openAddEventModal } from "../redux/actions";
import { selectAgendaItemDragging, selectAgendaItemPosition } from "../redux/selectors";
const styles = theme => ({
    card: {
        maxWidth: 400
    },
    media: {
        height: 0,
        paddingTop: "56.25%" // 16:9
    },
    actions: {
        display: "flex"
    },
    expand: {
        transform: "rotate(0deg)",
        transition: theme.transitions.create("transform", {
            duration: theme.transitions.duration.shortest
        }),
        marginLeft: "auto",
        [theme.breakpoints.up("sm")]: {
            marginRight: -8
        }
    },
    expandOpen: {
        transform: "rotate(180deg)"
    },
    avatar: {
        backgroundColor: red[500]
    },
    root: {
        flexGrow: 1,
        maxWidth: 500
    }
});

class AgendaView extends React.Component {
    state = {
        value: 0
    };

    handleChange = (event, value) => {
        this.setState({ value });
    };

    handleChangeIndex = index => {
        this.setState({ value: index });
    };

    onDragStart = (view, item) => {
        this.props.setAgendaItemDragging(view, item);
    };

    onDragEnd = () => {
        if (this.props.agendaItemPosition !== false) {
            this.props.openAddEventModal(this.props.agendaItemPosition);
        }
    };
    render() {
        const classes = this.props.classes;
        const theme = this.props.theme;
        const clickedDay = this.props.clickedDay ? this.props.clickedDay : "No day selected";

        return (
            <Card
                className="card"
                style={{
                    gridColumnStart: 2,
                    gridColumnEnd: 3,
                    gridRowStart: 1,
                    gridRowEnd: 3
                }}
            >
                <CardHeader
                    title="Agenda"
                    subheader={`${clickedDay}`}
                    avatar={
                        <Avatar aria-label="Recipe" className={classes.avatar}>
                            <AgendaIcon />
                        </Avatar>
                    }
                />
                <CardContent style={{ overflow: "scroll" }}>
                    <Tabs
                        value={this.state.value}
                        onChange={this.handleChange}
                        style={{ width: "100%" }}
                        fullWidth
                        indicatorColor="primary"
                        textColor="primary"
                    >
                        <Tab
                            style={{
                                minWidth: 50,
                                height: "100%",
                                label: {
                                    fontSize: "600em"
                                }
                            }}
                            icon={<TodayIcon />}
                        />
                        <Tab style={{ minWidth: 50 }} icon={<PersonIcon />} />
                        <Tab style={{ minWidth: 50 }} icon={<LocalShippingIcon />} />
                        <Tab style={{ minWidth: 50 }} icon={<BuildIcon />} />
                    </Tabs>
                    <SwipeableViews
                        axis={theme.direction === "rtl" ? "x-reverse" : "x"}
                        index={this.state.value}
                        onChangeIndex={this.handleChangeIndex}
                    >
                        <OverviewList onDragStart={this.onDragStart} onDragEnd={this.onDragEnd} />
                        <EmployeeList onDragStart={this.onDragStart} onDragEnd={this.onDragEnd} />
                        <MachinesList onDragStart={this.onDragStart} onDragEnd={this.onDragEnd} />
                        <EquipmentList onDragStart={this.onDragStart} onDragEnd={this.onDragEnd} />
                    </SwipeableViews>
                </CardContent>
            </Card>
        );
    }
}

export default withStyles(styles, { withTheme: true })(
    connect(
        store => {
            return {
                clickedDay: selectClickedDayTimeBlock(store),
                agendaItemDragging: selectAgendaItemDragging(store),
                agendaItemPosition: selectAgendaItemPosition(store)
            };
        },
        { setAgendaItemDragging, openAddEventModal }
    )(AgendaView)
);
